import { useMutation, useQuery } from 'react-query';
import { SkillsScoringOptionsService } from '@api/SkillsScoringOptionsService';
import { onDefaultError } from '../helpers/commonHelpers';

// List Skills Scoring Options
const useListSkillsScoringOptions = ([page_no, searchText, status], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['skills-scoring-options-list', page_no, searchText, status],
    SkillsScoringOptionsService.listSkillsScoringOptions,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};

// Add Skills Scoring Option
const useAddSkillsScoringOptions = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillsScoringOptionsService.addSkillsScoringOption, {
    onSuccess,
    onError,
  });
};

// Update Skills Scoring Option
const useUpdateSkillsScoringOptions = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillsScoringOptionsService.updateSkillsScoringOption, {
    onSuccess,
    onError,
  });
};

// Delete Skills Scoring Option
const useDeleteSkillsScoringOptions = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillsScoringOptionsService.deleteSkillsScoringOption, {
    onSuccess,
    onError,
  });
};

// View Skills Scoring Option
const useViewSkillsScoringOptions = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['skills-scoring-options-view', id],
    () => SkillsScoringOptionsService.viewSkillsScoringOption(id),
    {
      onSuccess,
      onError,
    }
  );
};

// Change Status of Skills Scoring Option
const useStatusChangeSkillsScoringOptions = (onSuccess, onError = onDefaultError) => {
  return useMutation(SkillsScoringOptionsService.statusChangeSkillsScoringOption, {
    onSuccess,
    onError,
  });
};

export {
  useListSkillsScoringOptions,
  useAddSkillsScoringOptions,
  useViewSkillsScoringOptions,
  useUpdateSkillsScoringOptions,
  useDeleteSkillsScoringOptions,
  useStatusChangeSkillsScoringOptions,
};